import apiClient from './api'
import { AxiosError } from 'axios'

export function extractApiMessage(error: unknown, fallback: string): string {
  if (
    error instanceof AxiosError &&
    error.response?.data &&
    typeof error.response.data === 'object' &&
    'message' in error.response.data &&
    typeof error.response.data.message === 'string'
  ) {
    return error.response.data.message
  }
  return fallback
}

export async function verifyEmail(token: string): Promise<void> {
  await apiClient.get('/auth/verifyEmail', { params: { token } })
}

export async function resendVerificationToken(email: string): Promise<void> {
  await apiClient.post('/auth/resendVerificationToken', null, { params: { email } })
}
